import React, { useState } from 'react';
import {
  Avatar,
  Card,
  DisplayText,
  Link,
  TextStyle,
  Tippy
} from '@superops/ui-design-system';
import { isEmpty } from 'lodash';
import { getIntials } from '@nile/components/src/Pages/SystemTrayChatPage/ChatTitle';
import {
  dompurifier,
  downloadHack as downloadHackHelper
} from '@nile/components/src/Utils/helpers';
import {
  EVENT,
  postMessageToWails
} from '@nile/components/src/Pages/SystemTrayChatPage/constants';
import {
  AttachmentPreviewer,
  DATE_TIME_FORMAT,
  DateTimeFormatter
} from '@nile/components';
import { SVGIcon } from '@superops/super-icons';
import envConfig from '@nile/home/src/Config/env';
import dayjs from 'dayjs';

function ConversationBubble(props) {
  const {
    isSelf,
    data,
    key,
    isCompact,
    user,
    center = false,
    template = false,
    type = null,
    sendMessage,
    isHttp = false,
    threadData,
    isWeb,
    customHeaders
  } = props;

  const [formatterAttachment, setFormatterAttachment] = useState([]);
  const [showAttachmentPreview, setShowAttachmentPreview] = useState({
    show: false,
    index: 0
  });

  const conversationData = isHttp ? data : data?.data?.conversation;
  const messageContent = isHttp
    ? data?.content
    : data?.data?.conversation?.content;

  const failureReason = isHttp
    ? data?.failureReason
    : data?.data?.conversation?.failureReason;

  const chatReadInfo = isHttp
    ? data?.conversationStatus
    : data?.data?.conversation?.conversationStatus;

  const messageAttachment = isHttp
    ? data?.attachments
    : data?.data?.conversation?.attachments;

  const ChatAvatar = (
    <>
      {!isEmpty(user?.name) && !isCompact ? (
        <div className="mlr5" title={user?.name}>
          <Avatar initials={getIntials(user?.name)} size="small" customer />
        </div>
      ) : (
        <></>
      )}
    </>
  );

  const handleMessageClick = () => {
    if (type === EVENT.TEMPLATE && sendMessage) {
      sendMessage({
        ...data,
        event: EVENT.INITIATE_CONVERSATION
      });
    }
  };

  const postDowndloadToWails = (downloadDetails, attachmentName) => {
    if (!isWeb) {
      const agentProperties = JSON.parse(
        sessionStorage.getItem('agentProperties')
      );
      postMessageToWails({
        eventName: 'DOWNLOAD_FILE',
        data: {
          url: downloadDetails.href,
          timeout: 300,
          httpMethod: 'GET',
          headers: {
            'asset-id': customHeaders?.AssetId || agentProperties?.AssetId,
            'asset-token':
              customHeaders?.AssetToken || agentProperties?.AssetToken,
            'app-acc': customHeaders?.AppAcc || agentProperties?.AppAcc,
            reqType: 'assetUser'
          },
          fileName: attachmentName
        }
      });
    }
  };

  const downloadImage = async (attachmentName) => {
    const baseURL = localStorage?.getItem('apiDomain') + envConfig.fileRoot;
    const downloadDetails = new URL(`${baseURL}/agent_download`);
    downloadDetails.search = new URLSearchParams({
      module: 'CONVERSATION_THREAD_ATTACHMENT',
      details: JSON.stringify({
        threadId: threadData?.threadId,
        conversationId: conversationData?.conversationId,
        fileName: attachmentName
      })
    });

    if (isWeb) {
      try {
        downloadHackHelper({
          href: downloadDetails.href,
          downloadFileName: attachmentName
        });
      } catch (err) {
        console.log(err);
      }
    } else {
      try {
        postDowndloadToWails(downloadDetails, attachmentName);
      } catch (err) {
        console.log(err);
      }
    }
  };

  function formatAttachmentForPreview(attachment, cb) {
    try {
      const baseURL = localStorage?.getItem('apiDomain') + envConfig.fileRoot;
      const downloadDetails = new URL(`${baseURL}/agent_download`);
      downloadDetails.search = new URLSearchParams({
        module: 'CONVERSATION_THREAD_ATTACHMENT',
        details: JSON.stringify({
          threadId: threadData?.threadId,
          conversationId: conversationData?.conversationId,
          fileName: attachment?.fileName
        })
      });
      setFormatterAttachment([
        {
          name: attachment.fileName,
          url: downloadDetails.href,
          type: attachment.fileName.substr(
            attachment.fileName.lastIndexOf('.') + 1,
            attachment.fileName.length
          )
        }
      ]);
      if (cb) cb();
    } catch (err) {
      console.log('Error while opening attachment');
    }
  }

  function openAttachmentPreview(attachment) {
    if (attachment) {
      formatAttachmentForPreview(attachment, () => {
        setShowAttachmentPreview({
          ...showAttachmentPreview,
          show: true,
          index: 0
        });
      });
    }
  }

  const closePreviwer = () => {
    setShowAttachmentPreview({
      ...showAttachmentPreview,
      show: false
    });
  };

  const screenshotOnclickHandler = (el) => {
    const fileType = el.fileName.substr(
      el.fileName.lastIndexOf('.') + 1,
      el.fileName.length
    );
    switch (fileType) {
      case 'png':
      case 'jpeg':
      case 'jpg':
      case 'JPG':
      case 'JPEG':
      case 'PNG':
        if (isWeb) {
          openAttachmentPreview(el);
        } else {
          downloadImage(el?.fileName);
        }
        break;
      default:
        downloadImage(el?.fileName);
        break;
    }
  };

  let conversationDate = dayjs();

  if (isWeb) {
    if (isHttp) {
      conversationDate = data?.time;
    } else {
      conversationDate = dayjs(Number(data?.epochMillis))
        .tz('GMT')
        .format(DATE_TIME_FORMAT);
    }
  } else {
    const timeToConvert = isHttp ? data?.time : Number(data?.epochMillis);
    conversationDate = dayjs.utc(timeToConvert).local();
  }

  return (
    <div
      className={`p1020 fx fcol ${center ? 'jctr' : ''} ${
        isSelf ? 'jend' : ''
      }`}
      key={key}
    >
      {!isSelf && ChatAvatar}
      {template && (
        <div className="mb10">
          <TextStyle>{data?.title}</TextStyle>
        </div>
      )}

      <Card
        variant={isSelf ? 'discussion' : 'card'}
        bubbleAlignment={center ? false : isSelf ? 'topRight' : 'topLeft'}
      >
        <div
          className={`p1520 nonDraggable ${center ? 'ptr' : ''}`}
          onClick={handleMessageClick}
          aria-hidden
        >
          <div
            className="message-content"
            dangerouslySetInnerHTML={{
              __html: dompurifier(messageContent)
            }}
          />
          {!isEmpty(messageAttachment) && (
            <div className="flex g3 mbt5 wrap">
              {messageAttachment?.map((el) => (
                <div className="w50">
                  <Card border="secondary">
                    <div className="flex-center g10 p5 ptr">
                      <div className="flex">
                        <SVGIcon name="AttachImage" size="sm" />
                      </div>
                      <div
                        className="flex f11 ellipsis"
                        onClick={() => screenshotOnclickHandler(el)}
                      >
                        <Link>{el?.originalFileName}</Link>
                      </div>
                      <div
                        className="flex"
                        onClick={() => downloadImage(el?.fileName)}
                      >
                        <SVGIcon name="Download" size="sm" />
                      </div>
                    </div>
                  </Card>
                </div>
              ))}
            </div>
          )}
          {!template && (
            <div className="flex jctr mt4 jend g3">
              <div className="f22">
                <DisplayText>
                  <TextStyle variation="subdued">
                    <DateTimeFormatter
                      type={!isHttp && isWeb ? 'toTechTimeZone' : 'dateTime'}
                      date={conversationDate}
                    />
                  </TextStyle>
                </DisplayText>
              </div>
              {!isEmpty(failureReason) && (
                <div className="flex-center">
                  <Tippy html={`${failureReason?.message}`}>
                    <SVGIcon name="InlineError" size="xs" color="red" />
                  </Tippy>
                </div>
              )}
              {isSelf && chatReadInfo === 'SEEN' && (
                <div className="flex-center">
                  <SVGIcon name="EyeVisible" size="sm" />
                </div>
              )}
            </div>
          )}
        </div>
      </Card>
      {isSelf && ChatAvatar}
      {showAttachmentPreview.show && (
        <AttachmentPreviewer
          showPreviewer={showAttachmentPreview.show}
          closePreviwer={closePreviwer}
          list={formatterAttachment}
          selectedIndex={showAttachmentPreview.index}
        />
      )}
    </div>
  );
}

export default ConversationBubble;
